import { MoveVariantsToCollectionDialog } from "~/components/collections/dialogs/MoveVariantsToCollectionDialog"
import { RemoveVariantsFromCollectionDialog } from "~/components/collections/dialogs/RemoveVariantsFromCollectionDialog"
import Commandbar from "~/components/planning/Commandbar"
import { useVariantsByIds } from "~/hooks/useVariants"
import { intersection, uniqBy } from "lodash"

type MultiEditSkuSettingsPanelProps = {
  selectedVariantIds: string[]
  selectedVariantCount: number
  clearSelectedIds: () => void
  collectionIds: number[] | undefined
}

export function MultiEditSkuCollectionPanel({
  selectedVariantIds,
  selectedVariantCount,
  clearSelectedIds,
  collectionIds,
}: MultiEditSkuSettingsPanelProps) {
  const variants = useVariantsByIds(selectedVariantIds)
  const allCollectionIds = uniqBy(
    variants.flatMap((v) => v.collections),
    "id",
  ).map((c) => Number(c.id))

  const collectionId = intersection(collectionIds ?? [], allCollectionIds)[0]

  return (
    <>
      {selectedVariantCount > 0 && (
        <Commandbar count={selectedVariantCount} onClear={clearSelectedIds}>
          {collectionId !== undefined && (
            <>
              <MoveVariantsToCollectionDialog
                variantIds={selectedVariantIds}
                sourceCollectionId={collectionId}
                onSuccess={clearSelectedIds}
              />
              <RemoveVariantsFromCollectionDialog
                variantIds={selectedVariantIds}
                collectionId={collectionId}
                onSuccess={clearSelectedIds}
              />
            </>
          )}
        </Commandbar>
      )}
    </>
  )
}
